// extracted by mini-css-extract-plugin
export default {"container":"chatbot_container__npevg","--collapsed":"chatbot_--collapsed__ZLsxL"};